import Grid from "@mui/material/Grid2";
import React from "react";
import Paper from "@mui/material/Paper";
import AreaCoverage from "./AreaCoverage";
import useDebugInformation from "../../../../../../../../hooks/useDebugInformation";
import NumberedHeader from "../../../../../../../Shared/NumberedHeader";
import { useAppSelector } from "@store/hooks";

const name = "JobCoverage";

type Props = {
    parent: string
}

const JobCoverage: React.FC<Props> = ({ parent }) => {
    const problemCoverageValid = useAppSelector(({ state }) => state.ProblemCoverageValid);
    const postcodeValid = useAppSelector(({ temp }) => temp.ProblemAddressActiveSearch);
    const problemAddressString = useAppSelector(({ ui }) => ui.ProblemAddressString);

    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { parent, problemCoverageValid })
    return (
        <Paper sx={(theme) => ({
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
            padding: theme.spacing(2),
            [theme.breakpoints.up(600 + Number(theme.spacing(3)) * 2)]: {
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
                padding: theme.spacing(2),
            },
            '& input': { height: "1em" }

        })} elevation={4} >
            <Grid container spacing={1}>
                <NumberedHeader number="4" description="AREA COVERAGE" variant={problemCoverageValid ? "green" : "red"} />
                {postcodeValid && problemAddressString && <AreaCoverage parent={debugName} />}
            </Grid>
        </Paper >
    )
}

JobCoverage.displayName = name;


export default React.memo(JobCoverage)